import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { ORDER_DETAILS_QUERY } from './operations';
import { ERROR_MESSAGE } from '../Messages/Messages';
import {
  AccountBlock,
  SectionHeading,
  TmntText,
  Loading,
} from '../Common';
import OrderDetailsContent from './OrderDetailsContent';
import InvalidOrderErrorPage from './InvalidOrderErrorPage';
import RnEOrderDetailsContent from './ReturnExchangeOrderDetailsBlock/RnEOrderDetailsContent';

export default function OrderDetailsBlock() {
  const [variables, setVariables] = useState(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    const orderId = searchParams.get('orderNumber');
    const email = searchParams.get('orderEmail');
    const channel = searchParams.get('channel');
    const placedTime = searchParams.get('placedTime');

    if (!orderId) return;

    const vars = channel === 'store' && placedTime
      ? { orderId, channel: 'store', placedTime }
      : { orderId, email };

    setVariables(vars);
  }, []);

  const { loading, error, data } = useQuery(ORDER_DETAILS_QUERY, {
    variables,
    context: { batch: true },
    ssr: false,
  });

  if (error) return ERROR_MESSAGE;

  const { orderDetails = {} } = data || {};
  const { success, errors, orderDetailItems = {} } = orderDetails;
  const {
    heading, status, isEmpty, isRnEOrder,
  } = orderDetailItems || {};

  const hasErrors = errors?.length > 0;
  const invalidOrderError = errors?.find(
    (err) => err.message?.key === 'ERR_ENTEREDINVALIDORDERNUMBER',
  );

  if (!success && hasErrors) {
    if (invalidOrderError) {
      return (
        <InvalidOrderErrorPage
          title={data?.textFor?.invalidOrderHeader}
          content={data?.textFor?.errorInvalidOrderContent}
        />
      );
    }
    return ERROR_MESSAGE;
  }

  return (
    <Loading isLoading={loading}>
      {!loading && (
        <div className="order-details-block" data-testid="order-details-block">
          <AccountBlock
            heading={(
              <SectionHeading>
                <span className="h3" data-testid="order-details-block-heading">
                  <TmntText tmnt={heading} />
                </span>
              </SectionHeading>
            )}
            rightHeading={
              !isEmpty ? (
                <SectionHeading alignedRight icon={status?.value}>
                  <span className="h3" data-testid="order-details-block-status">
                    <TmntText tmnt={status?.label} />
                  </span>
                </SectionHeading>
              ) : null
            }
          >
            {isRnEOrder ? (
              <RnEOrderDetailsContent rneQueryData={data} />
            ) : (
              <OrderDetailsContent queryData={data} />
            )}
          </AccountBlock>
        </div>
      )}
    </Loading>
  );
}
